import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react'

interface ActiveConversationContextType {
  activeConversationId: string | null
  setActiveConversationId: (id: string | null) => void
  isConversationViewed: (conversationId: string) => boolean
}

const ActiveConversationContext = createContext<ActiveConversationContextType | undefined>(undefined)

export function ActiveConversationProvider({ children }: { children: ReactNode }) {
  const [activeConversationId, setActiveConversationId] = useState<string | null>(null)

  const isConversationViewed = useCallback(
    (conversationId: string) => {
      return activeConversationId === conversationId
    },
    [activeConversationId]
  )

  return (
    <ActiveConversationContext.Provider
      value={{
        activeConversationId,
        setActiveConversationId,
        isConversationViewed,
      }}
    >
      {children}
    </ActiveConversationContext.Provider>
  )
}

export function useActiveConversation() {
  const context = useContext(ActiveConversationContext)
  // Return no-op functions if context is not available (for components outside provider)
  if (!context) {
    return {
      activeConversationId: null,
      setActiveConversationId: () => {},
      isConversationViewed: () => false,
    }
  }
  return context
}
